import PropTypes from 'prop-types'
import React from 'react'

import './styles.css'

// "What do you want to make first?" (SPEC-052 FR-11) — one question, three
// paths. Choosing a path sequences the page (that path's lessons instead of
// all sixteen); interest tagging happens silently upstream when a lead_token
// identifies the lead, so this step never asks for anything but the click.
function PathChooser({ question, paths, chosenSlug = null, onChoose }) {
  return (
    <section className="lm-paths wrapper">
      <span className="lm-paths__eyebrow">Step 1 of 2</span>
      <h2 className="lm-paths__title">{question}</h2>
      <div className="lm-paths__grid" role="radiogroup" aria-label={question}>
        {paths.map((path) => (
          <button
            key={path.slug}
            type="button"
            role="radio"
            aria-checked={chosenSlug === path.slug}
            className={`lm-paths__card${
              chosenSlug === path.slug ? ' -chosen' : ''
            }`}
            onClick={() => onChoose(path)}
          >
            <span className="lm-paths__card-title">{path.title}</span>
            {path.description && (
              <span className="lm-paths__card-description">
                {path.description}
              </span>
            )}
          </button>
        ))}
      </div>
    </section>
  )
}

PathChooser.propTypes = {
  question: PropTypes.string.isRequired,
  paths: PropTypes.arrayOf(
    PropTypes.shape({
      slug: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string,
      tag: PropTypes.string
    })
  ).isRequired,
  chosenSlug: PropTypes.string,
  onChoose: PropTypes.func.isRequired
}

export default PathChooser
